export default __webpack_public_path__ + "static/media/ShaynaLovelace.96ad14c9.png";